import { UserServiceService } from "./../services/user-service/user-service.service";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { ProjectsService } from "../services/projects/projects.service";
@Component({
  selector: "app-inventory-report",
  templateUrl: "./inventory-report.component.html",
  styleUrls: ["./inventory-report.component.css"],
})
export class InventoryReportComponent implements OnInit {
  monthly_sources_residential: any;
  brokers_residential: any;
  monthly_report: any;
  monthly_yearly_report: any;
  daily_residential_reservations: any;
  hold_reports: any;
  eois_reports: any;

  userProfile: any = JSON.parse(window.localStorage.getItem("userProfile"));
  view: any;

  projects: any;
  projectsDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  agentsDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  unitTypesDropdownSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };
  filter_form: FormGroup;

  project_id: any;
  source_id: any;
  agent_id: any;
  broker_id: any;
  types: any;

  userData: any = JSON.parse(window.localStorage.getItem("userProfile"));

  allSources;
  allEvents;
  allAgents;

  selectedSources: any = [];

  contracts_filter = false;
  sources_filter = false;
  brokers_filter = false;
  eois_filter = false;

  isLoading = false;

  agent_sales_filter = false;
  agents_sales_projects;
  agents_sales_data;

  agent_activities_filter = false;
  agents_activities_actions;
  agents_activities_data;

  agent_activities_leads_filter = false;
  agents_activities_leads_data;

  // loading alg
  loading_texts = [
    "Initiating Report",
    "Calculate Data",
    "Grouping Results",
    "Loading",
  ];

  loader = {
    index: 0,
    dot: 0,
    maxDot: 3,
    text: this.loading_texts[0],
    interval: null,
  };

  page = 1;

  sourcePage = 1;

  views_conf = {
    filters: false,
    charts: false,
  };

  charts: any = {
    eoi_accumulative: {},
    eoi_daily: {},
    eoi_monthly: {},
    eoi_yearly: {},
    matching: {},
    post_date_analysis: {
      months: {},
      years: {},
    },
  };

  chartOptions: any = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      gridLines: {
        display: false,
      },
    },

    layout: {
      padding: 10,
    },
    elements: {
      line: {
        fill: "origin",
        radius: 5,
        tension: 0.4,
      },
    },
  };

  downloading_export: boolean = false;

  unit_types: any;
  unit_types_filter: boolean = false;

  unit_types_status: any;
  unit_types_status_filter: boolean = false;

  unit_design_types: any;

  project_units_report: any;
  project_units_report_filter: boolean = false;

  eastshire_units_report: any;
  eastshire_units_report_filter: boolean = false;

  season_inventory_report: any;
  season_inventory_report_filter: boolean = false;

  totalSoldCount = 0;
  totalSoldArea = 0;
  totalSoldPrice = 0;
  totalSoldMaint = 0;
  totalSoldFinal = 0;
  totalUnsoldCount = 0;
  totalUnsoldArea = 0;
  totalUnsoldPrice = 0;
  totalUnsoldMaint = 0;
  totalUnsoldFinal = 0;

  manager_sales_report_filter: boolean = false;
  pc_sales_report_filter: boolean = false;

  overseas_sales_report_filter: boolean = false;
  channel_sales_report_filter: boolean = false;

  projects_units_yearly_report: any;
  projects_units_yearly_report_filter: boolean = false;
  pc_target_report_filter: boolean = false;

  managers_target_report_filter: boolean = false;

  years = [
    2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024,
    2025, 2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033,
  ];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private projectService: ProjectsService,
    private formBuilder: FormBuilder,
    private leadsService: LeadsService,
    private userService: UserServiceService
  ) {
    this.view = "units_types";
    console.log(this.userData);
  }

  ngOnInit() {
    this.getUnitDesignTypes();
    this.createFilterForm();
    this.getAllProjects();
    this.getAllAgents();
    this.setView(this.view);
  }

  getUnitDesignTypes() {
    this.projectService.getUnitDesignTypes().subscribe((res: any) => {
      this.unit_design_types = res.map((type, index) => {
        return {
          name: type,
          id: index,
        };
      });
    });
  }

  createFilterForm() {
    this.filter_form = this.formBuilder.group({
      // from_date: ['moment(new Date()).format("YYYY-MM-DD")'],
      // to_date: [moment(new Date()).format("YYYY-MM-DD")]
      from_date: null,
      to_date: null,
      year: null,
    });
  }

  getAllSources() {
    this.projectService.getAllSources().subscribe((res: any) => {
      this.allSources = res;
      console.log("************sources***********", this.allSources);
    });
  }

  getAllAgents() {
    this.leadsService.getAgents().subscribe((data: any) => {
      this.allAgents = data;
    });
  }

  get from_date() {
    return this.filter_form.get("from_date").value;
  }

  get to_date() {
    return this.filter_form.get("to_date").value;
  }

  get year() {
    return this.filter_form.get("year").value;
  }
  // get sources_ids() {
  //   return this.filter_form.get("sources_ids").value;
  // }

  getAllProjects() {
    this.projectService.getProjects().subscribe(
      (data: any) => {
        this.projects = data.data;
      },
      (err) => {}
    );
  }

  onItemSelect(item: any) {
    // console.log(item);
    // let ids =
  }

  onProjectSelectionChange() {
    // console.log(this.project_id);
    // if (this.is_filter) {
    //   this.filter();
    // } else {
    let ids = [];
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }

    if (ids.length > 0) {
      let projects_ids_string = ids.join(",");
      this.getMonthlyReport(projects_ids_string);
    } else {
      this.getMonthlyReport();
    }
    // }
  }

  onSelectAll(items: any) {}

  private extractIds(values: any[] = []): any[] {
    if (!Array.isArray(values)) {
      return [];
    }

    return values
      .map((value) => (value && value.id !== undefined ? value.id : value))
      .filter((value) => value !== null && value !== undefined && value !== "");
  }

  private appendProjectFilters(params: any, selectedProjects: any[] = []) {
    const projectIds = this.extractIds(selectedProjects);
    const projectIdsString = projectIds.join(",");

    params["projects_ids"] = projectIdsString;
    params["project_ids"] = projectIdsString;
    params["project_id"] = projectIds.length === 1 ? projectIds[0] : null;
  }

  private appendTypeFilters(params: any, selectedTypes: any[] = []) {
    const typeNames = Array.isArray(selectedTypes)
      ? selectedTypes
          .map((type) => (type && type.name !== undefined ? type.name : type))
          .filter((type) => type !== null && type !== undefined && type !== "")
      : [];
    const typesString = typeNames.join(",");

    params["types"] = typesString;
    params["unit_types"] = typesString;
    params["type"] = typesString;
  }

  filter() {
    // to do filter all reports
    let ids = [];
    let projects_ids_string = "";
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }
    if (ids.length > 0) {
      projects_ids_string = ids.join(",");
    }
    console.log("===============================================");
    let sourcesIds = [];
    let sources_ids_string = "";
    if (this.source_id) {
      this.source_id.forEach((source) => {
        sourcesIds.push(source.id);
      });
    }
    if (sourcesIds.length > 0) {
      sources_ids_string = sourcesIds.join(",");
    }
    console.log(
      "======================**=========================",
      sources_ids_string
    );
    let eventsIds = [];
    let events_ids_string = "";
    if (eventsIds.length > 0) {
      events_ids_string = eventsIds.join(",");
    }

    let brokersIds = [];
    let brokers_ids_string = "";
    if (this.broker_id) {
      this.broker_id.forEach((broker) => {
        brokersIds.push(broker.id);
      });
    }
    if (brokersIds.length > 0) {
      brokers_ids_string = brokersIds.join(",");
    }

    let agentsIds = [];
    let agents_ids_string = "";
    if (this.agent_id) {
      this.agent_id.forEach((agent) => {
        agentsIds.push(agent.id);
      });
    }
    if (agentsIds.length > 0) {
      agents_ids_string = agentsIds.join(",");
    }
    console.log("======================**=========================");
    console.log(
      projects_ids_string,
      sources_ids_string,
      this.from_date,
      this.to_date
    );
    let typesNames = [];
    let types_names_string = "";
    console.log(this.types);
    let params: any = {};
    if (this.types) {
      this.types.forEach((type) => {
        typesNames.push(type.name);
      });
    }
    if (typesNames.length > 0) {
      types_names_string = typesNames.join(",");
    }
    this.appendProjectFilters(params, this.project_id);
    this.appendTypeFilters(params, this.types);
    console.log(types_names_string);
    if (this.view == "units_types") {
      this.unit_types_filter = true;
      this.getUnitTypesReports(params);
    }
    if (this.view == "units_types_status") {
      this.unit_types_status_filter = true;
      this.getUnitTypesStatus(params);
    }
    if (this.view == "project_units") {
      this.project_units_report_filter = true;
      this.getProjectUnitsReports(params);
    }
    if (this.view == "eastshire_units") {
      this.eastshire_units_report_filter = true;
      this.getEastshireUnitsReports(params);
    }
    if (this.view == "season_inventory") {
      this.season_inventory_report_filter = true;
      this.getSeasonInventoryReports(params);
    }
    if (this.view == "projects_units_yearly_report") {
      params["projects_ids"] = projects_ids_string;
      params["date_from"] = this.from_date;
      params["date_to"] = this.to_date;
      params["agent_ids"] = agents_ids_string;
      this.projects_units_yearly_report_filter = true;
      this.getProjectsUnitsYearlyReports(params);
    }
    // TODO filters sales agents
  }

  filterReports() {}

  reset() {
    this.filter_form.reset();
    // this.getMonthlyReport();
    this.project_id = "";
    this.source_id = "";
    this.agent_id = "";
    this.broker_id = "";
    // this.is_filter = false;
    this.contracts_filter = false;
    this.sources_filter = false;
    this.eois_filter = false;
    this.agent_sales_filter = false;
    this.unit_types_filter = false;
    this.unit_types_status_filter = false;
    this.project_units_report_filter = false;
    this.eastshire_units_report_filter = false;
    this.season_inventory_report_filter = false;
    this.manager_sales_report_filter = false;
    this.pc_sales_report_filter = false;
    this.overseas_sales_report_filter = false;
    this.channel_sales_report_filter = false;
    this.projects_units_yearly_report_filter = false;
    this.pc_target_report_filter = false;
    this.managers_target_report_filter = false;
    this.setView(this.view);
  }

  getMonthlyReport(project_ids?, from_date?, to_date?) {
    this.isLoading = true;
    this.projectService.getMonthlyReport(project_ids).subscribe(
      (res: any) => {
        this.isLoading = false;
        this.monthly_report = res;
      },
      (err) => {
        this.isLoading = false;
        console.log(err);
      }
    );
  }

  getUnitTypesReports(params: any = {}) {
    if (params.is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService.getUnitTypesReports(params).subscribe(
      (res: any) => {
        if (params.is_export) {
          window.open(res);
        } else {
          this.unit_types = res;
        }
        console.log(this.unit_types);
        this.downloading_export = false;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.downloading_export = false;
        this.isLoading = false;
      }
    );
  }

  getUnitTypesStatus(params: any = {}) {
    if (params.is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService.getUnitTypesStatus(params).subscribe(
      (res: any) => {
        if (params.is_export) {
          window.open(res);
        } else {
          this.unit_types_status = res;
        }
        console.log(this.unit_types_status);
        this.downloading_export = false;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.downloading_export = false;
        this.isLoading = false;
      }
    );
  }

  getProjectUnitsReports(params: any = {}) {
    if (params.is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService.getProjectUnitsReports(params).subscribe(
      (res: any) => {
        if (params.is_export) {
          window.open(res);
        } else {
          this.project_units_report = res;
        }
        this.downloading_export = false;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.downloading_export = false;
        this.isLoading = false;
      }
    );
  }

  getEastshireUnitsReports(params: any = {}) {
    if (params.is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService.getEastshireUnitsReports(params).subscribe(
      (res: any) => {
        if (params.is_export) {
          window.open(res);
        } else {
          this.eastshire_units_report = res;
        }
        this.downloading_export = false;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.downloading_export = false;
        this.isLoading = false;
      }
    );
  }

  getSeasonInventoryReports(params: any = {}) {
    if (params.is_export) {
      this.downloading_export = true;
      this.projectService.getSeasonInventoryReports(params).subscribe(
        (res: any) => {
          window.open(res);
          this.downloading_export = false;
        },
        (err) => {
          console.log(err);
          this.downloading_export = false;
        }
      );
      return;
    }

    this.isLoading = true;
    const totalReq = this.projectService.getTotalUnitReport(params);
    const soldReq = this.projectService.getSoldReservationReport(params);
    const unsoldReq = this.projectService.getUnsoldUnitReport(params);

    Observable.forkJoin([totalReq, soldReq, unsoldReq]).subscribe(
      (results: any[]) => {
        const [totalRes, soldRes, unsoldRes] = results;
        this.season_inventory_report = this.mergeReports(
          totalRes,
          soldRes,
          unsoldRes
        );
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  totalTotalCount = 0;
  totalTotalArea = 0;
  totalTotalPrice = 0;
  totalTotalMaint = 0;
  totalTotalFinal = 0;

  mergeReports(totalRes: any[], soldRes: any[], unsoldRes: any[]) {
    const mergedMap = new Map();

    const getEntry = (projectName, typeName, floorName) => {
      const key = `${projectName}_${typeName}_${floorName}`;
      if (!mergedMap.has(key)) {
        mergedMap.set(key, {
          project_name: projectName,
          type_name: typeName,
          floor_name: floorName,

          total_count: 0,
          total_area: 0,
          total_price: 0,
          total_maint: 0,
          total_total_with_maint: 0,

          sold_count: 0,
          sold_percentage: 0,
          sold_area: 0,
          sold_price: 0,
          sold_maint: 0,
          sold_total_with_maint: 0,

          unsold_count: 0,
          unsold_percentage: 0,
          unsold_area: 0,
          unsold_price: 0,
          unsold_maint: 0,
          unsold_total_with_maint: 0,
        });
      }
      return mergedMap.get(key);
    };

    // Helper to ensure array
    const toArray = (data: any) => (Array.isArray(data) ? data : data ? [data] : []);

    // 1. Process Total Report
    toArray(totalRes).forEach((project) => {
      if (project.unit_types) {
        project.unit_types.forEach((type) => {
          if (type.floors) {
            type.floors.forEach((floor) => {
              const entry = getEntry(
                project.project_name,
                type.unit_type_name,
                floor.floor_number
              );
              entry.total_count = floor.total_units || 0;
              entry.total_area = floor.build_area_sum || 0;
              entry.total_price = floor.selling_price_sum || 0;
              entry.total_maint = floor.maintenance_sum || 0;
              entry.total_total_with_maint = floor.total_with_maintenance || 0;
            });
          }
        });
      }
    });

    // 2. Process Sold Report
    toArray(soldRes).forEach((project) => {
      if (project.unit_types) {
        project.unit_types.forEach((type) => {
          if (type.floors) {
            type.floors.forEach((floor) => {
              const entry = getEntry(
                project.project_name,
                type.unit_type_name,
                floor.floor_number
              );
              entry.sold_count = floor.sold_units || 0;
              entry.sold_area = floor.build_area_sum || 0;
              entry.sold_price = floor.selling_price_sum || 0;
              entry.sold_maint = floor.maintenance_sum || 0;
              entry.sold_total_with_maint = floor.total_with_maintenance || 0;
            });
          }
        });
      }
    });

    // 3. Process Unsold Report
    toArray(unsoldRes).forEach((project) => {
      if (project.unit_types) {
        project.unit_types.forEach((type) => {
          if (type.floors) {
            type.floors.forEach((floor) => {
              const entry = getEntry(
                project.project_name,
                type.unit_type_name,
                floor.floor_number
              );
              entry.unsold_count = floor.unsold_units || 0;
              entry.unsold_area = floor.build_area_sum || 0;
              entry.unsold_price = floor.selling_price_sum || 0;
              entry.unsold_maint = floor.maintenance_sum || 0;
              entry.unsold_total_with_maint =
                floor.total_with_maintenance || 0;
            });
          }
        });
      }
    });

    this.totalTotalCount = 0;
    this.totalTotalArea = 0;
    this.totalTotalPrice = 0;
    this.totalTotalMaint = 0;
    this.totalTotalFinal = 0;

    this.totalSoldCount = 0;
    this.totalSoldArea = 0;
    this.totalSoldPrice = 0;
    this.totalSoldMaint = 0;
    this.totalSoldFinal = 0;

    this.totalUnsoldCount = 0;
    this.totalUnsoldArea = 0;
    this.totalUnsoldPrice = 0;
    this.totalUnsoldMaint = 0;
    this.totalUnsoldFinal = 0;

    const types = Array.from(mergedMap.values());
    types.forEach((item: any) => {
      // Calculate Percentages
      if (item.total_count > 0) {
        item.sold_percentage = Math.round(
          (item.sold_count / item.total_count) * 100
        );
        item.unsold_percentage = Math.round(
          (item.unsold_count / item.total_count) * 100
        );
      } else {
        // Fallback if total_count is missing
        const computedTotal = item.sold_count + item.unsold_count;
        if (computedTotal > 0) {
          item.sold_percentage = Math.round(
            (item.sold_count / computedTotal) * 100
          );
          item.unsold_percentage = Math.round(
            (item.unsold_count / computedTotal) * 100
          );
        }
      }

      this.totalTotalCount += item.total_count;
      this.totalTotalArea += item.total_area;
      this.totalTotalPrice += item.total_price;
      this.totalTotalMaint += item.total_maint;
      this.totalTotalFinal += item.total_total_with_maint;

      this.totalSoldCount += item.sold_count;
      this.totalSoldArea += item.sold_area;
      this.totalSoldPrice += item.sold_price;
      this.totalSoldMaint += item.sold_maint;
      this.totalSoldFinal += item.sold_total_with_maint;

      this.totalUnsoldCount += item.unsold_count;
      this.totalUnsoldArea += item.unsold_area;
      this.totalUnsoldPrice += item.unsold_price;
      this.totalUnsoldMaint += item.unsold_maint;
      this.totalUnsoldFinal += item.unsold_total_with_maint;
    });

    return { types };
  }

  getProjectsUnitsYearlyReports(params: any = {}) {
    if (params.is_export) this.downloading_export = true;
    else this.isLoading = true;
    this.projectService.getProjectsUnitsYearlyReports(params).subscribe(
      (res: any) => {
        if (params.is_export) {
          window.open(res);
        } else {
          this.projects_units_yearly_report = res;
        }
        this.downloading_export = false;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.downloading_export = false;
        this.isLoading = false;
      }
    );
  }

  setView(tab: String) {
    this.views_conf.filters = false;
    this.views_conf.charts = null;
    this.view = tab;
    this.filter_form.reset();
    this.project_id = "";
    this.source_id = "";
    this.agent_id = "";
    this.broker_id = "";
    if (tab == "units_types") {
      this.getUnitTypesReports();
    }
    if (tab == "units_types_status") {
      this.getUnitTypesStatus();
    }
    if (tab == "project_units") {
      this.getProjectUnitsReports();
    }
    if (tab == "eastshire_units") {
      this.getEastshireUnitsReports();
    }
    if (tab == "season_inventory") {
      this.getSeasonInventoryReports();
    }
    if (tab == "projects_units_yearly_report") {
      this.getProjectsUnitsYearlyReports();
    }
  }

  isHelpDeskUser() {
    // return this.userData.role == "Helpdesk Supervisor" || this.userData.role == "Helpdesk Agent"
    return this.userData.role == "Helpdesk Agent";
  }

  onAgentsSelectionChange() {}

  enableLoading() {
    this.isLoading = true;

    this.loader.index = 0;
    this.loader.dot = 0;
    this.loader.text = this.loading_texts[0];

    this.loader.interval = setInterval(() => {
      if (!this.isLoading) return this.disableLoading();

      if (this.loader.dot < this.loader.maxDot) {
        this.loader.dot++;
        this.loader.text += ".";
      } else {
        this.loader.dot = 0;
        if (this.loader.index < this.loading_texts.length - 1) {
          this.loader.index++;
        } else {
          this.loader.index = 0;
        }
        this.loader.text = this.loading_texts[this.loader.index];
      }
    }, 1000);
  }

  disableLoading() {
    this.isLoading = false;
    clearInterval(this.loader.interval);
  }

  exportToExcel() {
    const table = document.getElementById("inventory-table");
    if (!table) return;

    const html = table.outerHTML;

    // Add styles to ensure borders and colors show up in Excel
    const style = `
    <style>
        table { border-collapse: collapse; width: 100%; }
        th, td { border: 1px solid black; text-align: center; vertical-align: middle; padding: 5px; }
        .status-total { background-color: #e2e3e5; color: #383d41; font-weight: bold; }
        .total-bg { background-color: #f8f9fa; }
        .status-sold { background-color: #d4edda; color: #155724; font-weight: bold; }
        .sold-bg { background-color: #f1f8f3; }
        .status-unsold { background-color: #f8d7da; color: #721c24; font-weight: bold; }
        .unsold-bg { background-color: #fff5f5; }
        .font-weight-bold { font-weight: bold; }
        .text-center { text-align: center; }
    </style>
    `;

    const fullHtml = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
    <head>
        <meta charset="utf-8" />
        <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>Inventory Report</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->
        ${style}
    </head>
    <body>
        ${html}
    </body>
    </html>
    `;

    const blob = new Blob([fullHtml], { type: "application/vnd.ms-excel" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Inventory_Report_${new Date().getTime()}.xls`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  getPriceValue(price: any): number | null {
    if (price === null || price === undefined) {
      return null;
    }

    if (typeof price === "number") {
      return price;
    }

    if (typeof price === "object" && price.unitPrice !== undefined) {
      return price.unitPrice;
    }

    return null;
  }

  getPriceSerial(price: any): string {
    if (!price || typeof price !== "object") {
      return "-";
    }

    return price.serial ? String(price.serial) : "-";
  }

  togglePriceSerial(zone: any, priceType: "minimum" | "maximum") {
    if (!zone) {
      return;
    }

    const key = priceType === "minimum" ? "showMinimumSerial" : "showMaximumSerial";
    const source = zone[priceType];

    if (!source || typeof source !== "object" || !source.serial) {
      zone[key] = false;
      return;
    }

    zone[key] = !zone[key];
  }

  downloadReport() {
    console.log(this.view);
    let ids = [];
    if (this.project_id) {
      this.project_id.forEach((project) => {
        ids.push(project.id);
      });
    }
    let projects_ids_string = ids.join(",");
    let sourcesIds = [];
    let sources_ids_string = "";
    if (this.source_id) {
      this.source_id.forEach((source) => {
        sourcesIds.push(source.id);
      });
    }
    if (sourcesIds.length > 0) {
      sources_ids_string = sourcesIds.join(",");
    }
    let eventsIds = [];
    let events_ids_string = "";
    if (eventsIds.length > 0) {
      events_ids_string = eventsIds.join(",");
    }

    let brokersIds = [];
    let brokers_ids_string = "";
    if (this.broker_id) {
      this.broker_id.forEach((broker) => {
        brokersIds.push(broker.id);
      });
    }
    if (brokersIds.length > 0) {
      brokers_ids_string = brokersIds.join(",");
    }

    let agentsIds = [];
    let agents_ids_string = "";
    if (this.agent_id) {
      this.agent_id.forEach((agent) => {
        agentsIds.push(agent.id);
      });
    }
    if (agentsIds.length > 0) {
      agents_ids_string = agentsIds.join(",");
    }
    let typesNames = [];
    let types_names_string = "";
    if (this.types) {
      this.types.forEach((type) => {
        typesNames.push(type.name);
      });
    }
    if (typesNames.length > 0) {
      types_names_string = typesNames.join(",");
    }
    let params: any = {};
    this.appendProjectFilters(params, this.project_id);
    this.appendTypeFilters(params, this.types);
    switch (this.view) {
      case "units_types":
        params["is_export"] = true;
        this.getUnitTypesReports(params);
        break;
      case "units_types_status":
        params["is_export"] = true;
        this.getUnitTypesStatus(params);
        break;
      case "project_units":
        params["is_export"] = true;
        this.getProjectUnitsReports(params);
        break;
      case "eastshire_units":
        params["is_export"] = true;
        this.getEastshireUnitsReports(params);
        break;
      case "season_inventory":
        params["is_export"] = true;
        this.getSeasonInventoryReports(params);
        // this.exportToExcel(); وقفت الكود
        break;
      case "projects_units_yearly_report":
        params["projects_ids"] = projects_ids_string;
        params["date_from"] = this.from_date;
        params["date_to"] = this.to_date;
        params["agent_ids"] = agents_ids_string;
        params["is_export"] = true;
        this.getProjectsUnitsYearlyReports(params);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/inventory-report/inventory-report.component.ts